module.exports = __webpack_public_path__ + "img/0Q3B2213_FoamcoreMatted_MockedUp.d262f77f.jpg";